import Header from './components/Header';
import Hero from './components/Hero';
import SectionAbout from './components/SectionAbout';
import SectionFeatures from './components/SectionFeatures';
import SectionMedia from './components/SectionMedia';
import SectionRanking from './components/SectionRanking';
import SectionCarousel from './components/SectionCarousel';
import SectionContact from './components/SectionContact';
import SectionCards from './components/SectionCards';
import SectionTopics from './components/SectionTopics';
import SectionFAQ from './components/SectionFAQ';
import SectionIndex from './components/SectionIndex';
import SectionApp from './components/SectionApp';
import SectionComments from './components/SectionComments';
import SectionUpdates from './components/SectionUpdates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionAbout />
        <SectionFeatures />
        <SectionMedia />
        <SectionRanking />
        <SectionCarousel />
        <SectionContact />
        <SectionCards />
        <SectionTopics />
        <SectionFAQ />
        <SectionIndex />
        <SectionApp />
        <SectionComments />
        <SectionUpdates />
      </main>
      <Footer />
    </>
  );
}